import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  module: {
    id: 'portal.views.courseWorking.hero.heading.module',
    defaultMessage: 'Module',
    description: 'Module label in course working heading',
  },
  expandFullCourseProgress: {
    id: 'portal.views.courseWorking.button.expandFullCourseProgress',
    defaultMessage: 'Expand full course progress',
    description: 'Expand full course progress label',
  },
  collapseFullCourseProgress: {
    id: 'portal.views.courseWorking.button.collapseFullCourseProgress',
    defaultMessage: 'Collapse full course progress',
    description: 'Collapse full course progress label',
  },
  previous: {
    id: 'portal.views.courseWorking.button.previous',
    defaultMessage: 'Previous',
    description: 'Previous button label',
  },
  saveAndContinue: {
    id: 'portal.views.courseWorking.button.saveAndContinue',
    defaultMessage: 'Save & Continue',
    description: 'Save & Continue button label',
  },
  fiveDayNamePart: {
    id: 'portal.views.courseWorking.fiveDayNamePart',
    defaultMessage: '5 Day',
    description: '5 Day part in course title',
  },
});

export default messages;
